<template>
  <Container
    class="mb-96 w-full pt-80 mobile-only:mt-44 sm:w-[600px]"
    :class="{ 'mobile-only:px-8': inFooter, 'mobile-only:px-24': !inFooter }"
  >
    <form
      id="search-chatbot"
      class="relative w-full rounded-[30px] border border-blue-600 bg-white bg-gradient-to-b from-blue-900 to-blue-700 px-20 py-24 shadow-xl md:max-w-screen-xs md:p-40"
      @submit.prevent="search"
    >
      <div
        class="absolute left-1/2 top-0 -translate-x-1/2 translate-y-[-100px]"
      >
        <SpriteSymbol name="cassia" class="size-144" />
        <span class="sr-only">
          {{ $texts('search.chatbotTitle') }}
        </span>
      </div>
      <div class="my-24 text-left text-white">
        <h3 v-if="inFooter" class="text-lg font-semibold tracking-wide">
          {{
            $texts('search.notFound')
          }}
        </h3>
        <p class="text-lg tracking-wide">
          {{ $texts('search.askCassia') }}
        </p>
      </div>
      <div
        class="search-input-group relative flex gap-16 rounded-large bg-white py-12 pl-24 pr-12"
        role="search"
      >
        <input
          id="ask-cassia"
          ref="input"
          v-model="searchTerm"
          type="search"
          autocomplete="off"
          name="searchterm"
          class="input flex-1 border-none px-0 text-body focus:border-none focus:outline-none focus:ring-0"
          spellcheck="false"
          aria-owns="searchterm-suggestions"
          :aria-label="
            $texts('search.askCassia', 'Ask our AI assistant Cassia')
          "
          :placeholder="
            $texts('search.askCassiaPlaceholder')
          "
        />

        <button
          type="submit"
          class="button is-bubble size-48 !rounded-large text-white transition-colors"
          :class="hasText ? 'bg-blue-700' : 'bg-gray-200'"
          :disabled="!hasText"
          @click.prevent="search"
        >
          <SpriteSymbol name="arrow-up-long" class="!m-0 size-full" />
          <span class="sr-only">
            {{ $texts('submitSearch') }}
          </span>
        </button>
      </div>
    </form>
  </Container>
</template>

<script setup lang="ts">
const { $texts } = useEasyTexts()

const { inFooter } = defineProps<{
  inFooter?: boolean
}>()

const searchTerm = ref('')
const hasText = computed(() => searchTerm.value.trim().length > 0)

const router = useRouter()
const language = useCurrentLanguage()
const { dataLayerPush } = useAnalytics()

const search = () => {
  dataLayerPush({
    event: 'site_search',
    search_term: searchTerm.value,
  })

  if (inFooter) {
    navigateTo(`/${language.value}/cassia?q=${searchTerm.value}`)
  } else {
    router.push({
      name: 'search',
      query: {
        text: searchTerm.value,
      },
    })
  }
}

defineBlokkliFragment({
  name: 'cassia_widget',
  label: 'Cassia Widget',
})
</script>

<style lang="postcss">
.search-input-group {
  @apply transition-shadow;

  &:focus-within {
    @apply outline outline-2 outline-offset-1 outline-violet-700;
  }
}
</style>
